import { unividApi } from "./base.js";

export const extendedApiOrganization = unividApi.injectEndpoints({
  endpoints: (build) => ({
    getOrganization: build.query({
      query: (organizationId) => ({
        url: `organization/${organizationId}`,
        method: "get",
      }),
      providesTags: (result, error, organizationId) => [
        { type: "Organization", id: organizationId },
      ],
    }),
    setOrganization: build.query({
      query: ({ organizationId, data }) => ({
        url: `organization/${organizationId}`,
        method: "put",
        data,
      }),
    }),
    putOrganization: build.mutation({
      // Can be merged with the call setOrganization
      query: ({ organizationId, ...data }) => ({
        url: `organization/${organizationId}/edit`,
        method: "put",
        data,
      }),
      invalidatesTags: (result, error, { organizationId }) => [
        { type: "Organization", id: organizationId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const useGetOrganizationQuery =
  extendedApiOrganization.endpoints.getOrganization.useQuery;
export const useGetOrganizationState =
  extendedApiOrganization.endpoints.getOrganization.useQueryState;
export const useSetOrganizationQuery =
  extendedApiOrganization.endpoints.setOrganization.useQuery;
export const useSetOrganizationState =
  extendedApiOrganization.endpoints.setOrganization.useQueryState;
export const usePutOrganizationMutation =
  extendedApiOrganization.endpoints.putOrganization.useMutation;
